<style scoped>
.search-wrap {
  margin-bottom: 15px;
}
</style>

<template>
  <div>
    <div class="search-wrap">
      <el-button v-if="isSuperAdmin" type="primary" icon="el-icon-plus" @click="openDialog()">新增配置</el-button>
    </div>

    <el-table :data="tableData" border v-loading="loading">
      <el-table-column prop="provinceName" label="省"></el-table-column>
      <el-table-column prop="cityName" label="市"></el-table-column>
      <el-table-column prop="districtName" label="区县"></el-table-column>
      <el-table-column prop="sceneUrl" label="场景地址" show-overflow-tooltip></el-table-column>
      <el-table-column prop="sessionKey" label="sessionKey" show-overflow-tooltip></el-table-column>
      <el-table-column prop="appId" label="appId" show-overflow-tooltip></el-table-column>
      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-button type="text" @click="openDialog(scope.row)">编辑</el-button>
          <el-button type="text" style="color: #f56c6c;" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      style="margin-top: 15px;"
      background
      layout="total, prev, pager, next"
      :current-page="page"
      :page-size="limit"
      :total="total"
      @current-change="handlePageChange"
    ></el-pagination>

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="600px">
      <el-form :model="form" :rules="rules" ref="formRef" label-width="100px">
        <el-form-item label="所属区县" prop="district">
          <el-cascader
            style="width: 100%;"
            v-model="selectedOptions"
            :options="regionData"
            :props="{ value: 'value', label: 'label', children: 'children' }"
            @change="handleChange"
            placeholder="请选择所属区县"
            :disabled="!isSuperAdmin"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="场景地址" prop="sceneUrl">
          <el-input type="textarea" :rows="3" v-model="form.sceneUrl" placeholder="请输入四维轻云场景地址"></el-input>
        </el-form-item>
        <el-form-item label="sessionKey" prop="sessionKey">
          <el-input type="textarea" :rows="2" v-model="form.sessionKey" placeholder="请输入sessionKey"></el-input>
        </el-form-item>
        <el-form-item label="appId" prop="appId">
          <el-input v-model="form.appId" placeholder="请输入appId"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSave">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { regionData, CodeToText } from "element-china-area-data";

export default {
  data() {
    return {
      loading: false,
      tableData: [],
      page: 1,
      limit: 10,
      total: 0,
      dialogVisible: false,
      dialogTitle: "新增配置",
      regionData: regionData,
      selectedOptions: [],
      isSuperAdmin: false,
      currentDistrict: {
        provinceId: "",
        provinceName: "",
        cityId: "",
        cityName: "",
        districtId: "",
        districtName: ""
      },
      form: {
        id: null,
        provinceId: "",
        provinceName: "",
        cityId: "",
        cityName: "",
        districtId: "",
        districtName: "",
        sceneUrl: "",
        sessionKey: "",
        appId: ""
      },
      rules: {
        sceneUrl: [{ required: true, message: "请输入场景地址", trigger: "blur" }],
        sessionKey: [{ required: true, message: "请输入sessionKey", trigger: "blur" }],
        appId: [{ required: true, message: "请输入appId", trigger: "blur" }]
      }
    };
  },
  mounted() {
    this.initUserInfo();
    this.loadList();
  },
  methods: {
    initUserInfo() {
      try {
        const userInfoStr = localStorage.getItem("adminUserInfo");
        if (userInfoStr) {
          const userInfo = JSON.parse(userInfoStr);
          this.isSuperAdmin = userInfo.role === "SUPER_ADMIN";
          this.currentDistrict = {
            provinceId: userInfo.provinceId || "",
            provinceName: userInfo.provinceName || "",
            cityId: userInfo.cityId || "",
            cityName: userInfo.cityName || "",
            districtId: userInfo.districtId || "",
            districtName: userInfo.districtName || ""
          };
        }
      } catch (e) {
        console.error("initUserInfo error", e);
      }
    },
    loadList() {
      this.loading = true;
      this.$apis
        .get("/admin/districtMapConfig/page", { page: this.page, limit: this.limit })
        .then(res => {
          this.loading = false;
          if (res && res.data && res.data.code == 200) {
            this.tableData = res.data.data.records || [];
            this.total = res.data.data.total || 0;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    handlePageChange(val) {
      this.page = val;
      this.loadList();
    },
    openDialog(row) {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.formRef.clearValidate();
        if (row) {
          this.dialogTitle = "编辑配置";
          this.form = { ...row };
          this.selectedOptions = [row.provinceId, row.cityId, row.districtId];
        } else {
          this.dialogTitle = "新增配置";
          if (!this.isSuperAdmin) {
            // 非超管自动填充当前区县
            this.form = {
              id: null,
              provinceId: this.currentDistrict.provinceId,
              provinceName: this.currentDistrict.provinceName,
              cityId: this.currentDistrict.cityId,
              cityName: this.currentDistrict.cityName,
              districtId: this.currentDistrict.districtId,
              districtName: this.currentDistrict.districtName,
              sceneUrl: "",
              sessionKey: "",
              appId: ""
            };
            this.selectedOptions = [
              this.currentDistrict.provinceId,
              this.currentDistrict.cityId,
              this.currentDistrict.districtId
            ].filter(Boolean);
          } else {
            this.form = {
              id: null,
              provinceId: "",
              provinceName: "",
              cityId: "",
              cityName: "",
              districtId: "",
              districtName: "",
              sceneUrl: "",
              sessionKey: "",
              appId: ""
            };
            this.selectedOptions = [];
          }
        }
      });
    },
    handleChange(value) {
      this.form.provinceId = value[0] || "";
      this.form.provinceName = CodeToText[value[0]] || "";
      this.form.cityId = value[1] || "";
      this.form.cityName = CodeToText[value[1]] || "";
      this.form.districtId = value[2] || "";
      this.form.districtName = CodeToText[value[2]] || "";
    },
    handleSave() {
      this.$refs.formRef.validate(valid => {
        if (!valid) return;
        if (!this.form.districtId) {
          this.$message.error("请选择所属区县");
          return;
        }
        this.$apis.post("/admin/districtMapConfig/saveOrUpdate", this.form).then(res => {
          if (res && res.data && res.data.code == 200) {
            this.$message.success("保存成功");
            this.dialogVisible = false;
            this.loadList();
          } else {
            this.$message.error(res.data.msg || "保存失败");
          }
        });
      });
    },
    handleDelete(row) {
      this.$confirm("确认删除该配置？", "提示", { type: "warning" })
        .then(() => {
          this.$apis.post("/admin/districtMapConfig/delete?id=" + row.id).then(res => {
            if (res && res.data && res.data.code == 200) {
              this.$message.success("删除成功");
              this.loadList();
            } else {
              this.$message.error(res.data.msg || "删除失败");
            }
          });
        })
        .catch(() => {});
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/page/districtMapConfig.vue